import { Link } from 'react-router-dom';

const Features = () => {
  return (
    <div className="app-background max-w-7xl mx-auto px-3 sm:px-6 py-6 sm:py-12">
      {/* Hero Section */}
      <div className="hero-gradient rounded-2xl shadow-2xl p-6 sm:p-12 md:p-16 text-white relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-32 sm:w-48 md:w-64 h-32 sm:h-48 md:h-64 opacity-10">
          <svg viewBox="0 0 100 100" fill="white">
            <circle cx="50" cy="50" r="40" />
            <rect x="30" y="20" width="40" height="60" rx="5" />
          </svg>
        </div>
        <div className="absolute bottom-0 left-0 w-24 sm:w-36 md:w-48 h-24 sm:h-36 md:h-48 opacity-10">
          <svg viewBox="0 0 100 100" fill="white">
            <circle cx="50" cy="50" r="45" />
          </svg>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <div className="text-5xl sm:text-6xl md:text-7xl mb-3 sm:mb-4 paddle-swing">🏸</div>
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-extrabold tracking-tight mb-2 sm:mb-4">
            PicklePro
            <span className="block text-yellow-300 text-xl sm:text-2xl md:text-3xl mt-1 sm:mt-2 font-light">
              The Smart Court Booking System
            </span>
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-green-50 max-w-2xl mx-auto mb-6 sm:mb-8 leading-relaxed">
            Book courts instantly, manage your schedule, and keep the game going.
            Professional pickleball court management made simple.
          </p>
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
            <Link
              to="/book"
              className="px-6 sm:px-8 py-3 sm:py-4 bg-yellow-400 hover:bg-yellow-300 text-green-900 font-bold rounded-xl shadow-lg transition transform hover:scale-105 hover:shadow-2xl flex items-center gap-2 text-sm sm:text-base"
            >
              <span>🎾</span> Book a Court Now
            </Link>
            <Link
              to="/calendar"
              className="px-6 sm:px-8 py-3 sm:py-4 bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white font-bold rounded-xl border-2 border-white/50 transition transform hover:scale-105 flex items-center gap-2 text-sm sm:text-base"
            >
              <span>📅</span> Check Calendar
            </Link>
          </div>
        </div>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mt-6 sm:mt-12">
        <div className="bg-white rounded-2xl shadow-md hover-lift p-5 sm:p-8 border-l-4 border-green-600">
          <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">🏸</div>
          <h3 className="text-lg sm:text-xl font-bold text-green-800 mb-2">Easy Booking</h3>
          <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
            Select your court and time with our intuitive grid. Click or drag to choose your slot instantly.
          </p>
        </div>
        
        <div className="bg-white rounded-2xl shadow-md hover-lift p-5 sm:p-8 border-l-4 border-yellow-500">
          <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">📊</div>
          <h3 className="text-lg sm:text-xl font-bold text-green-800 mb-2">Smart Availability</h3>
          <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
            View real-time availability. Confirmed bookings are clearly marked so you always know what's free.
          </p>
        </div>
        
        <div className="bg-white rounded-2xl shadow-md hover-lift p-5 sm:p-8 border-l-4 border-green-600 sm:col-span-2 lg:col-span-1">
          <div className="text-4xl sm:text-5xl mb-3 sm:mb-4">👑</div>
          <h3 className="text-lg sm:text-xl font-bold text-green-800 mb-2">Owner Control</h3>
          <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
            Manage bookings, confirm pending reservations, and keep your courts organized with our dashboard.
          </p>
        </div>
      </div>

      {/* Stats Section */}
      <div className="mt-8 sm:mt-12 grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 text-center">
        <div className="bg-white rounded-xl shadow-sm p-4 sm:p-6">
          <div className="text-2xl sm:text-3xl font-bold text-green-700">30+</div>
          <div className="text-xs sm:text-sm text-gray-500">Courts Available</div>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4 sm:p-6">
          <div className="text-2xl sm:text-3xl font-bold text-yellow-600">1K+</div>
          <div className="text-xs sm:text-sm text-gray-500">Bookings Made</div>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4 sm:p-6">
          <div className="text-2xl sm:text-3xl font-bold text-green-700">4.9</div>
          <div className="text-xs sm:text-sm text-gray-500">User Rating ⭐</div>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4 sm:p-6">
          <div className="text-2xl sm:text-3xl font-bold text-yellow-600">99%</div>
          <div className="text-xs sm:text-sm text-gray-500">Satisfaction</div>
        </div>
      </div>
    </div>
  );
};

export default Features;